module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }), _c('a', {
    attrs: {
      "id": "author"
    }
  }, [_vm._v("Author’s Introduction")])]), _c('a', {
    attrs: {
      "id": "author"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A little over five miles to the northwest of Hazebrouck is the small and ancient town of Cassel. Built on top of a hill, which rises nearly 600 feet above sea level, it dominates the surrounding flat Flanders countryside. Half a mile to the east of Cassel is the wooded Mont des Récollets, standing some sixty feet lower and separated from the town by a shallow valley through which runs the modern day D916. In May 1940 this small hilltop town, together with the larger urban sprawl of Hazebrouck, became two of the lynchpins in the 48"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Division’s web of defence that held and protected the western face of the so-called Dunkerque Corridor. Created by Lord Gort, the British Commander-in-Chief, the ‘corridor’ was the escape route through which the bulk of the British forces were able to reach the evacuation beaches on the coast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Today, a line of canalized waterways, running south from Gravelines through Aire-sur-la-Lys towards Béthune, mark the western edge of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pays de Flandre")]), _vm._v(", while to the east, the A25 Autoroute from Dunkerque runs almost parallel with the Belgian border as it sweeps majestically south-east through Armentières and on to Lille. Now part of the greater "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nord-Pas de Calais,")]), _vm._v(" the region, which Charles de Gaulle called ‘a fatal avenue through which invading armies repeatedly passed’, has been has been one of the most fought over provinces in Europe.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0009-00.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Cassel rises 600 feet above the Flanders Plain")])])]), _c('a', {
    attrs: {
      "id": "VPS-10"
    }
  }, [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("Early History")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Making an annual appearance every Easter, two legendary giants – Reuze-Papa and Reuze Maman – are said to have created the hills at Cassel and Mont des Récollets when they tripped and deposited two huge piles of earth that they were carrying. These giants make their first appearance on Carnival Sunday, before Shrove Tuesday, and again on Easter Monday. Early records suggest the hill was occupied during the late Iron Age when it was probably the site of a hill fort. The town takes its name from the Roman development of the area when Cassel – renamed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Castellum Menapiorum")]), _vm._v(" - was absorbed into the Roman province of Gallia Belgica in 29 BC. After the collapse of the Roman Empire, Cassel and the surrounding land of Flanders passed into the hands of Baldwin ‘Iron Arm’, who became the first Count of Flanders in 864 AD. The town was destroyed by the Vikings in the late 9th century and rebuilt by Baldwin’s grandson, Arnulf I, in the 10th century. Two generations later in 1071, Arnulf III was killed during the First Battle of Cassel by forces allied to Robert the Friesian who fortified the hill and added a new set of walls built on the old Roman foundations. Although these wall are long gone, the pattern of streets and pathways in the town date back to this period.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0010-00.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The memorial on the D138 commemorating the Third Battle of Cassel in 1677")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In 1328 the Second Battle of Cassel was fought between Philip V of France and Nicolaas Zannekin, who commanded a rebel force intent on seizing Flanders. Zannekin’s defeat led to a period of relative calm but by the end of the 16th century Cassel’s position as a border town between France and the Spanish Netherlands saw both sides struggling for control of the town. In 1677 the Third Battle of Cassel took place to the west of the town, near Zuytpeene. This was a decisive victory for the French who defeated Dutch forces commanded by William II of Orange and absorbed much of the surrounding area into France. Today, the occasion is sometimes known as the Battle of the Peene and an obelisk memorial stands on the D138 between Noordpeene and Zuytpeene to commemorate the battle.")])]), _c('a', {
    attrs: {
      "id": "VPS-11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It was during the French Revolutionary Wars that Frederick, the ‘Grand Old Duke’ of York and Albany, was said to have marched 10,000 men up the hill. However, it should be said that the nursery rhyme originated well before the Revolutionary Wars and the link with Cassel must be regarded as dubious to say the least!")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0011-00.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Dominique-Joseph Vandamme")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the more well known residents of Cassel was Dominique-Joseph Vandamme, who commanded Napoleon’s III Corps at Waterloo in 1815. Granted permission to return from exile in 1819, he died in his native Cassel at his château – which is now in ruins - on the Rue Bollaert le Gavrain in 1829. The town memorial to Vandamme stands at the junction of Avenue Achille Samyn (D933) and Rue de Watten (D11). In 1848 the railway from Lille to Dunkerque was constructed, incorporating a new railway station for Cassel built at Bavinchove with a connecting tram service to the town. In 1934 this was replaced by a bus service, which still operates today.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("Hazebrouck")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The commemoration of legendary giants is also a feature of the Hazebrouck cultural calendar, when the town’s four giants are paraded. Rowland appears in the middle of Lent and again with his family during the first weekend in July. Twinned with the market town of Faversham in Kent, Hazebrouck can trace its beginnings back to the reign of Dagobert I, who cleared the area of forest in 630 AD, but it was not until 1122 that Charles the Good gave the town the name of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hasbruc")]), _vm._v(". Like Cassel, Hazebrouck was subjected to the ravages of wars, not only at the hands of Philip VI of France, who burned the town in 1347, but between the Spanish Netherlands and France in their struggle for territory. Hazebrouck was finally annexed by Louis XIV of France in 1678.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-11"
    }
  }, [_vm._v("It was the arrival of the railway that was largely responsible for the development ")]), _c('a', {
    attrs: {
      "id": "VPS-12"
    }
  }, [_vm._v("of Hazebrouck from a small market town to an important railway junction, circumstances which undoubtedly contributed to the expansion of the weaving and spinning industry in the 1860s.")])]), _c('a', {
    attrs: {
      "id": "VPS-12"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0012-00.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The modern town of Hazebrouck, looking north towards St-Sylvestre-Cappel. The photograph shows clearly the open nature of the town’s approaches compared to the hilltop fortifications of Cassel. The Church of Notre Dame, which was destroyed during the war and rebuilt in 1959, can be seen in the centre of the photograph.")])]), _vm._v(" "), _c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("The First World War")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-12"
    }
  }, [_vm._v("Cassel remained behind Allied lines in the war years of 1914-1918 and served as the military headquarters of Maréchal Ferdinand Foch between October 1914 and May 1915. His offices were on the first floor of the Hôtel de la Noble Cour, also known as Landshuys, in the Grand Place, a building which is now the Departmental Museum of Flanders. During his stay at Cassel he lived in the Hôtel de Schoebeque – then a private house - on Rue du Maréchal Foch where a memorial plaque on the wall, to the left of the street entrance, commemorates his links with the building. Foch was a frequent visitor to the Collégiale Notre-Dame de la Crypte near the Porte de Dunkerque; inside is a plaque commemorating his son and son-in-law who were lost in one of the early battles of the First World War. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aspirant")]), _vm._v(" Germain Foch and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Capitane")]), _vm._v(" Paul Bécourt were killed during the Battle of the Frontiers in August 1914. A monument to Foch, which was unveiled in July 1928 by President Pointcaré, stands behind the windmill on the highest ")]), _c('a', {
    attrs: {
      "id": "VPS-13"
    }
  }, [_vm._v("point in the town; a replica of which can be found in Grosvenor Gardens, near Victoria Station in London. The French returned to Cassel in November 1917.")])]), _c('a', {
    attrs: {
      "id": "VPS-13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The British moved to Cassel in 1916 under General Sir Herbert Plumer, who established his Second Army Headquarters at the Castel Yvonne in the Rue St Nicholas. The small square in which the 2/Gloucesters established their HQ in May 1940 was originally named in honour of General Plumer, but was changed more recently to honour Dominique-Joseph Vandamme; accordingly I have referred to the square in the text as Place du Général Vandamme.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Field Marshal Haig was a frequent visitor to Cassel and also used the Hôtel de Schoebeque as his residence when in the vicinity. The war artist William Orpen is closely associated with Cassel and amongst his many paintings is one of Plumer, which was painted in the Casino. Orpen also painted the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Household Brigade Passing to the Ypres Salient, Cassel")]), _vm._v(", in which he depicts the Porte d’Aire. His well-known painting of the courtyard at the Hôtel du Sauvage – now a restaurant – is a reminder of the popularity of the hotel which, Orpen tells us, was packed almost every night with officers from the Ypres Salient who were escaping the rigours of trench warfare ‘to eat, drink, play the piano and sing, forgetting their misery and discomfort for the moment’. The painting is now kept at the Imperial War Museum in London.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both Hazebrouck and Cassel felt the weight of the German Spring Offensive in 1918 when Operation Georgette was launched with the aim of capturing Hazebrouck and its railway marshalling yards to cut the supply routes to the BEF. The offensive opened on 9 April and two days later the forward units of the German Sixth Army were less than five miles from Hazebrouck, prompting Haig to issue his famous ‘backs to the wall’ order. Fortunately, the offensive lost its momentum and the arrival of much needed reinforcements brought the German advance to a halt. But it had been a close run thing, and the number of CWGC Cemeteries that dot the surrounding landscape must have served as a constant reminder to the men of 1940 that the area had already been fought over in 1918 by their fathers and uncles twenty-two years earlier.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0013-00.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Douglas Haig commanded the BEF during the First World War")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Cassel has changed relatively little over the years, in May 1940 Hazebrouck was considerably smaller than the modern town of today, which has seen residential and industrial development extending the town boundaries well beyond those of seventy-six years ago. Consequently, most of the positions occupied by the 1/Buckinghamshire Battalion (1/Bucks) during May 1940 have now vanished under the tide of expansion, and the inevitable post 1945 urban improvements that accompanied the town as it rebuilt itself as a road and rail junction. However, despite this, it is still possible to locate the approximate positions of several of the Buckinghamshire platoons and the location of Battalion HQ in the centre of town.")])]), _c('a', {
    attrs: {
      "id": "VPS-14"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0014-00.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Dunkerque and Western Flanders")])])]), _c('a', {
    attrs: {
      "id": "VPS-15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The German attack on Hazebrouck was initially from the west but, unlike Cassel, which benefitted from high ground, the openness of Hazebrouck was highlighted by the relative ease with which the German armoured units penetrated the town. An ease which, in retrospect, leads to the question: would the 1/Bucks’ defence of Hazebrouck have been more effective if Major Heyworth had reduced his perimeter and concentrated on exploiting the vulnerability of armoured fighting vehicles (AFVs) in urban areas? The narrow streets in Hazebrouck were well suited to this form of warfare, where the limited range of the battalion’s anti-tank weapons may well have been employed to greater effect. Certainly they were at an immediate disadvantage when the superior fire power and mobility of the 8"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Panzer Division surrounded, and began to systematically overwhelm, company positions on the outskirts of town. However, it must be said that it is doubtful whether the 1/Bucks would have been familiar with this type of defence or, indeed, were in a position to carry it out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By nightfall on 27 May, effective resistance at Hazebrouck had been crushed by the 8"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Panzer Division, leaving only Battalion HQ isolated in the centre of town until the survivors surrendered during the evening of 28 May. At Cassel, the fighting units stood their ground until the orders to withdraw finally arrived on 29 May, by which time they, too, were surrounded, in their case, by units of the 6"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Panzer Division.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Information concerning the deployment of the units at Cassel has focused on the detailed descriptions left by Captains Eric Jones, Bill Wilson and others of the 2nd Battalion Gloucestershire Regiment; detail which, rather frustratingly, is lacking in accounts left by the officers and men of the 4"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Oxford and Buckinghamshire Light Infantry (4/Ox and Bucks). In fact, the platoon positions of the 4/Ox and Bucks are only generally referred to as being in the eastern half of the town, although careful reading of the accounts of those who were there at the time, do provide an approximate location for each company.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fortunately, the Defence of Hazebrouck is focussed on a single infantry battalion and the battalion war diary offers a reasonably complete record of what happened. The historian is also fortunate in that the war diary of 98/Field Regiment provides another account of the fighting in and around the town. Moreover, there are several other accounts written by other officers and men who were there at the time, which help to give an overall picture of what took place.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-15"
    }
  }, [_vm._v("In ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Appendix#app1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1")]), _vm._v(" the reader will find notes on many of the individuals mentioned in the text, including the senior German officers. Many of the British officers and men were killed or captured during the breakout and their final resting places are noted, along with those who were captured. The ranks given to each individual are those that were held in May 1940.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When describing the fighting I have often referred to modern day road numbering in order to give the reader using current maps of the area a more "), _c('a', {
    attrs: {
      "id": "VPS-16"
    }
  }, [_vm._v("precise location. While some of the abbreviations in the text are self explanatory, others do require a modicum of explanation. I have used a form of abbreviation when describing units and formations, thus after its first mention in the text the 2"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("nd")]), _vm._v(" Battalion Gloucestershire Regiment becomes the 2/Gloucesters or more simply the Gloucesters. German army units are a little more complex. Within the infantry regiment there were three battalions – each one approximately the size of a British battalion – and, as with their British counterparts, the battalion was broken down into four companies of riflemen, who were given an Arabic numeral, for example, 3 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kompanie.")]), _vm._v(" Again, I have abbreviated when describing these units, thus Infantry Regiment 162 becomes IR162 while the second battalion within that regiment is abbreviated to II/IR162; or, in the case of panzer regiments, II/Pz10. In the same way, Artillery Regiment 76 is abbreviated to AR 76 and German Infantry Divisions are referred to in their abbreviated form, hence the 31"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("st")]), _vm._v(" Infantry Division becomes ID31. Equivalent German and British ranks referred to in the text are as follows:")])]), _c('a', {
    attrs: {
      "id": "VPS-16"
    }
  }, [_c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td45"
  }, [_vm._v("Lieutenant General")]), _vm._v(" "), _c('td', {
    staticClass: "td45_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Generaloberst")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("General der Panzertruppe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td45"
  }, [_vm._v("Major General")]), _vm._v(" "), _c('td', {
    staticClass: "td45_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalmajor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td45"
  }, [_vm._v("Colonel")]), _vm._v(" "), _c('td', {
    staticClass: "td45_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oberst")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td45"
  }, [_vm._v("Lieutenant Colonel")]), _vm._v(" "), _c('td', {
    staticClass: "td45_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oberstleutnant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td45"
  }, [_vm._v("Major")]), _vm._v(" "), _c('td', {
    staticClass: "td45_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Major")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td45"
  }, [_vm._v("Captain")]), _vm._v(" "), _c('td', {
    staticClass: "td45_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hauptmann")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td45"
  }, [_vm._v("Lieutenant")]), _vm._v(" "), _c('td', {
    staticClass: "td45_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oberleutnant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td45"
  }, [_vm._v("Second Lieutenant")]), _vm._v(" "), _c('td', {
    staticClass: "td45_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Leutnant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td45"
  }, [_vm._v("Corporal")]), _vm._v(" "), _c('td', {
    staticClass: "td45_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Unteroffizier")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td45"
  }, [_vm._v("Lance Corporal")]), _vm._v(" "), _c('td', {
    staticClass: "td45_1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gefreiter")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-583cdb18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Author_Introduction.vue
// module id = 75
// module chunks = 0